<template>
  <div class="toggleContainer">
    <label class="switch">
      <input type="checkbox" @change="toggle" ref="toggleCheckbox">
      <span class="slider"></span>
    </label>
  </div>
</template>
<script>
import dataStore from '@/dataStore';

export default {
  name: 'toggle',
  props: [
    'model'
  ],
  data() {
    return {
      state: dataStore.state
    }
  },
  mounted() {
    let savedState = dataStore.getProperty(this.model, this.state)
    this.$refs.toggleCheckbox.checked = savedState
  },
  methods: {
    toggle(e) {
      dataStore.setProperty(this.model, e.target.checked)
    }
  }
}
</script>
<style scoped>
label {margin: 0;}
.toggleContainer {text-align:right; display: flex; align-items: center; justify-content: flex-end;}
.switch {position: relative; width: 38px; height: 23px;}
</style>


// WEBPACK FOOTER //
// src/system/atoms/toggle.vue